// extracted by mini-css-extract-plugin
export default {"svg":"Loader_svg__p9FFL"};